import { getBasePath } from '@/utils/utils';

export const getUrlJump = (value: string, uid: string, type: string) => {
  // console.log("============", value, uid, type)
  const basePath = getBasePath();
  switch (value) {
    case 'performance':
      return `${basePath}/opinion/Overview?gameid=${uid}`;
    case 'gameStore':
      return `${basePath}/opinion/Feeds/Feeds?gameid=${uid}&tab=gameStore`;
    case 'socialMedia':
      return `${basePath}/opinion/Feeds/Feeds?gameid=${uid}&tab=socialMedia`;
    case 'newMedia':
      return `${basePath}/opinion/Feeds/Feeds?gameid=${uid}&tab=newMedia`;
    case 'overview':
      return `${basePath}/intelligence/topCharts/${type}Games/gamesDetails/${uid}/overview`;
    case 'rank':
      return `${basePath}/intelligence/topCharts/${type}Games/gamesDetails/${uid}/storeRank`;
    case 'metrics':
      return `${basePath}/intelligence/topCharts/${type}Games/gamesDetails/${uid}/stats`;
    default:
      return;
  }
}

export const getGameType = (gameIdx, gameList) => {
  // console.log(gameIdx, gameList)
  const findType = gameList.find((obj) => {
    return obj.unified_id === gameIdx
  })
  return findType.type;
}